/**
 * Port of `repos/opencode/packages/ui/src/components/collapsible.tsx`.
 *
 * Kobalte -> Radix. The DOM is the contract: `styles/primitives/collapsible.css` is
 * vendored byte-identical and selects on these `data-component` / `data-slot` /
 * `data-variant` values, so they must be emitted on the same elements upstream puts them.
 */

import * as RadixCollapsible from "@radix-ui/react-collapsible";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { Icon } from "../../ui/icon.tsx";

export interface CollapsibleProps
  extends ComponentPropsWithoutRef<typeof RadixCollapsible.Root> {
  variant?: "normal" | "ghost";
  children?: ReactNode;
}

function CollapsibleRoot({ variant = "normal", ...props }: CollapsibleProps) {
  return (
    <RadixCollapsible.Root data-component="collapsible" data-variant={variant} {...props} />
  );
}

function CollapsibleTrigger(
  props: ComponentPropsWithoutRef<typeof RadixCollapsible.Trigger>
) {
  return <RadixCollapsible.Trigger data-slot="collapsible-trigger" {...props} />;
}

function CollapsibleContent(
  props: ComponentPropsWithoutRef<typeof RadixCollapsible.Content>
) {
  return <RadixCollapsible.Content data-slot="collapsible-content" {...props} />;
}

function CollapsibleArrow(props: ComponentPropsWithoutRef<"div"> = {}) {
  return (
    <div data-slot="collapsible-arrow" {...props}>
      <span data-slot="collapsible-arrow-icon">
        <Icon name="chevron-down" size="small" />
      </span>
    </div>
  );
}

export const Collapsible = Object.assign(CollapsibleRoot, {
  Arrow: CollapsibleArrow,
  Trigger: CollapsibleTrigger,
  Content: CollapsibleContent
});
